<div class="wrapper__headerComponent container my-5">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-12">
        <h2 class="h3-tipografia-govco mb-4">
          {{tituloPrincipal}}
        </h2>
      </div>
    </div>

    <div class="row description-message">
      <p>{{seleccioneTitulo}}</p>
    </div>

    <div class="row">
      <div class="col-md-12">
        <select id="alertas-select" class="form-select" [(ngModel)]="idEncuesta" (change)="onEncuestaChange()">
          <option value="" disabled>{{seleccioneEncuesta}}</option>
          <option *ngFor="let encuesta of encuestas" [value]="encuesta.Id">
            {{ encuesta.Descripcion }}
          </option>
        </select>
      </div>
    </div>

    <div *ngIf="idEncuesta">
      <div class="row mt-3">
        <form [formGroup]="encuestaForm">
          <div class="row">
            <div class="col-md-12">
              <label for="descripcion" class="font-weight-bold">
                {{descripcionEncuesta}}: <span class="text-danger ng-star-inserted">*</span>
              </label>
              <input id="descripcion" type="text" class="form-control" formControlName="descripcion" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12">
              <label for="mensaje" class="font-weight-bold">
                {{mensajeEntrada}}: <span class="text-danger ng-star-inserted">*</span>
              </label>
              <input id="mensaje" type="text" class="form-control" formControlName="mensaje" />
            </div>
          </div>
        </form>

        <div class="mt-4">
          <div class="d-flex justify-content-end">
            <!--<button class="btn-govco outline-btn-govco"
                    [disabled]="encuestaSeleccionada.Cerrada"
                    (click)="cerrarEncuesta()">
              {{ 'encuestas.cerrar-encuesta' | translate }}
            </button>-->

            <button class="btn-govco outline-btn-govco ms-2"
                    (click)="habilitarEncuesta()"
                    aria-label="Habilitar encuesta">
              {{ (encuestaSeleccionada.Estado
              ? 'encuestas.deshabilitar-encuesta'
              : 'encuestas.habilitar-encuesta')
              | translate }}
            </button>

            <button class="btn-govco outline-btn-govco ms-2"
                    [disabled]="encuestaSeleccionada.Cerrada"
                    (click)="guardarEncuesta()"
                    aria-label="Guardar encuesta">
              {{saveSurvey}}
            </button>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="d-flex flex-column flex-xl-row align-items-xl-center justify-content-between mt-5">
          <h3 class="mb-3">{{preguntasTexto}}</h3>
          <div style="margin-left: 5rem; align-items: baseline;">
            <button class="btn-govco outline-btn-govco" (click)="crearPregunta()"
            aria-label="Crear pregunta">
              {{crearPreguntaTexto}}
            </button>
          </div>
        </div>

        <app-table
          [estiloEncabezado]="'height: auto !important;'"
          [datos]="preguntas"
          [columnas]="columnas"
          [paginacion]="false"
          [acciones]="acciones"
          (eventoAccion)="accionesPregunta($event)">
        </app-table>
      </div>
      <div class="row" *ngIf="mostrarTablaRespuestas">
        <div class="d-flex flex-column flex-xl-row align-items-xl-center justify-content-between mt-5">
          <h3 class="mb-3">{{respuestasTexto}}</h3>
        </div>

        <app-table
          [estiloEncabezado]="'height: auto !important;'"
          [datos]="respuestas"
          [columnas]="columnasRespuestas"
          [paginacion]="false"
          (evento)="filtrarRespuestas($event)">
        </app-table>
      </div>
      <div class="row align-items-center descargar-tablas">
        <!-- Título -->
        <div class="col-12 mb-2">
    <span class="descargar-tablas__titulo">
      {{ 'encuestas.descargar-info' | translate }}
    </span>
        </div>
        <div class="col-12 col-md-6 mb-2 d-flex align-items-center">
          <label for="fechaInicio" class="me-2 mb-0">
            {{ 'encuestas.info-asociada' | translate }}
          </label>
          <input
            id="fechaInicio"
            [(ngModel)]="fechaInicio"
            type="date"
            placeholder="dd/mm/aaaa"
            autocomplete="off"
            class="form-control" />
        </div>
        <div class="col-12 col-md-6 mb-2 d-flex align-items-center">
          <label for="fechaFin" class="me-2 mb-0">
            {{ 'encuestas.info-hasta' | translate }}
          </label>
          <input
            id="fechaFin"
            [(ngModel)]="fechaFin"
            [min]="fechaInicio"
            type="date"
            placeholder="dd/mm/aaaa"
            autocomplete="off"
            class="form-control" />
        </div>
        <div class="col-12 col-md-3 mt-2">
          <button class="btn-govco outline-btn-govco w-100" (click)="downloadExcel()"
            aria-label="Descargar respuestas de la encuesta">
            {{ 'encuestas.descargar' | translate }}
          </button>
        </div>
      </div>
    </div>

  </div>
</div>
